import { DraftModeStore } from './types';

export const filterDraftModeInitialState: DraftModeStore = {
  isDraftMode: false,
  generatedParams: '',
};
